// CORE
import { useEffect, useState } from "react";

// THIRD-PARTY LIBRARIES
import { Outlet, useLocation } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";

// COMPONENTS
import Header from "../header/index";
import Sidebar from "../sidebar/index";

// STYLES
import styles from "./styles/style.module.scss";

const Layout = (props) => {
    const lang = localStorage.getItem("lang") || "ar";
    const dir = lang === "ar" ? "rtl" : "ltr";
    const { pathname } = useLocation();

    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    const [offcanvasShow, setOffcanvasShow] = useState(false);
    const handleClose = () => setOffcanvasShow(false);

    useEffect(() => {
        setOffcanvasShow(false);
    }, [pathname]);

    return (
        <div className={`${styles["main-wrapper"]}`}>
            <div className="sidebar-desktop">
                <Sidebar sidebarCollapsed={sidebarCollapsed} />
            </div>
            <div className="sidebar-mobile">
                <Offcanvas
                    show={offcanvasShow}
                    onHide={handleClose}
                    scroll
                    placement={dir === "rtl" ? "end" : "start"}
                    className={styles["offcanvas"]}
                    closeButton
                >
                    <button
                        className="btn-close"
                        onClick={handleClose}
                        aria-label="btn-close"
                    ></button>
                    <Sidebar sidebarCollapsed={false} />
                </Offcanvas>
            </div>
            <div
                className={`content-wrap ${
                    sidebarCollapsed ? "content-collapsed" : ""
                }`}
                id="content-wrapper"
            >
                <Header
                    sidebarCollapsed={sidebarCollapsed}
                    setSidebarCollapsed={setSidebarCollapsed}
                    setOffcanvasShow={setOffcanvasShow}
                    logo={props?.logo}
                />
                <div className="content-container">
                    {props.children}
                    <Outlet />
                </div>
            </div>
        </div>
    );
};
export default Layout;
